import {MAP_URL} from "../../constants/urls";

export function specialistCommentListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function specialistCommentMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, specialistCommentId: json.result.objectId,
      conversationUrl: json.result.conversationId && MAP_URL.conversationAdminPanel+json.result.conversationId+"/show"}
  };
}

export function fixGetManySpecialistComments(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      specialistCommentsId: resource.objectId,
    })),
  };
}